
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.333 8h9.334c.4 0 .666.267.666.667s-.266.666-.666.666H5.333c-.4 0-.666-.266-.666-.666S4.933 8 5.333 8zM5.333 12.667h9.334c.4 0 .666.266.666.666s-.266.667-.666.667H5.333c-.4 0-.666-.267-.666-.667s.266-.666.666-.666zM14.667 17.333H5.333c-.4 0-.666.267-.666.667s.266.667.666.667h9.334c.4 0 .666-.267.666-.667s-.266-.667-.666-.667z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.867 1.333h.8A3.3 3.3 0 0120 4.667v16A3.3 3.3 0 0116.667 24H3.333A3.3 3.3 0 010 20.667v-16a3.3 3.3 0 013.333-3.334h.8C4.4.533 5.133 0 6 0h8c.867 0 1.6.533 1.867 1.333zm-1.867 0H6c-.4 0-.667.267-.667.667s.267.667.667.667h8c.4 0 .667-.267.667-.667S14.4 1.333 14 1.333zm2.667 21.334c1.133 0 2-.867 2-2v-16c0-1.134-.867-2-2-2h-.8C15.6 3.467 14.867 4 14 4H6c-.867 0-1.6-.533-1.867-1.333h-.8c-1.133 0-2 .866-2 2v16c0 1.133.867 2 2 2h13.334z","fill":"currentColor"}})])
          )
        }
      }
    